document.addEventListener('DOMContentLoaded', () => {
  const isMobile = () => window.matchMedia('(max-width: 60rem)').matches;

  const containers = document.querySelectorAll('.tabs-section');

  containers.forEach((container) => {
    const dropdown = container.querySelector('.tabs-dropdown');
    const button = container.querySelector('.tabs-dropdown-button');
    const buttonLabel = button.querySelector('.tabs-dropdown-label');
    const list = container.querySelector('.tabs-dropdown-container');
    const tabButtons = Array.from(container.querySelectorAll('.tabs-dropdown-option'));
    const tabPanelsContainer = container.querySelector('.tabs-container');
    const tabPanels = Array.from(tabPanelsContainer.children);
    const navControls = container.querySelector('.tabs-section-controls');
    const prevButton = container.querySelector('.tabs-section-controls-prev');
    const nextButton = container.querySelector('.tabs-section-controls-next');
    const navControlsBg = container.querySelector('.tabs-section-bg');

    button.setAttribute('aria-haspopup', 'listbox');

    tabButtons.forEach((tabBtn, i) => {
      const tabId = tabBtn.id || `${container.id || 'tabs'}-tab-${i}`;
      tabBtn.setAttribute('id', tabId);
      if (tabPanels[i]) {
        const panelId = tabPanels[i]?.id || `${tabId}-panel`;
        tabBtn.setAttribute('aria-controls', panelId);
        tabPanels[i].setAttribute('role', 'tabpanel');
        tabPanels[i].setAttribute('tabindex', '0');
        tabPanels[i].setAttribute('aria-labelledby', tabId);
        tabPanels[i].setAttribute('id', panelId);
      }
    });

    function updateTabListMode() {
      if (isMobile()) {
        button.setAttribute('aria-expanded', dropdown.classList.contains('is-open') ? 'true' : 'false');
        list.setAttribute('role', 'listbox');
        list.setAttribute('tabindex', '-1');
        list.classList.add('max-md:hidden');
        tabButtons.forEach((tabBtn, i) => {
          tabBtn.setAttribute('role', 'option');
          tabBtn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          tabBtn.setAttribute('tabindex', '-1');
        });
      } else {
        button.setAttribute('aria-expanded', 'false');
        list.setAttribute('role', 'tablist');
        list.removeAttribute('tabindex');
        list.classList.remove('max-md:hidden');
        tabButtons.forEach((tabBtn, i) => {
          tabBtn.setAttribute('role', 'tab');
          tabBtn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          tabBtn.setAttribute('tabindex', i === 0 ? '0' : '-1');
        });
      }
    }

    function updateSelection(index, scroll = true) {
      tabButtons.forEach((tabBtn, i) => {
        tabBtn.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tabBtn.classList.toggle('selected', i === index);
      });

      if (buttonLabel) {
        buttonLabel.textContent = tabButtons[index].querySelector('span').textContent;
      }

      tabPanels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if(i !== index){
          panel.setAttribute('inert', 'true');
        }else{
          panel.removeAttribute('inert');
        }
      });

      updateNavButtonState(index);
      
      const selectedBtn = tabButtons[index];
      if (selectedBtn && scroll) {
        selectedBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function openDropdown() {
      if (isMobile()) {
        dropdown.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        list.classList.remove('max-md:hidden');
        list.focus();
      }
    }

    function closeDropdown() {
      if (isMobile()) {
        dropdown.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        list.classList.add('max-md:hidden');
      }
    }

    function checkScrollbar() {
      if (list.scrollWidth > list.clientWidth) {
        navControls?.classList.add('has-scroll');
        navControlsBg?.classList.add('has-scroll');
        list?.classList.add('has-scroll');
      } else {
        navControls?.classList.remove('has-scroll');
        navControlsBg?.classList.remove('has-scroll');
        list?.classList.remove('has-scroll');
      }
    }

    function scrollTabIntoView(direction) {
      const selectedIdx = tabButtons.findIndex(btn => btn.classList.contains('selected'));
      let targetIdx = selectedIdx;
      if (direction === 'next') {
        targetIdx = Math.min(tabButtons.length - 1, selectedIdx + 1);
      } else if (direction === 'prev') {
        targetIdx = Math.max(0, selectedIdx - 1);
      }
      const targetBtn = tabButtons[targetIdx];
      if (targetBtn) {
        targetBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        updateSelection(targetIdx);
        updateNavButtonState(targetIdx);
      }
    }

    function updateNavButtonState(selectedIdx) {
      prevButton.disabled = selectedIdx === 0;
      nextButton.disabled = selectedIdx === tabButtons.length - 1;
    }

    button.addEventListener('click', (e) => {
      if (!isMobile()) return;

      e.preventDefault();

      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    button.addEventListener('keydown', (e) => {
      if (!isMobile()) return;

      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openDropdown();
        tabButtons[0].focus();
      }
    });

    tabButtons.forEach((tabBtn, i) => {
      tabBtn.addEventListener('click', () => {
        updateSelection(i);

        if (isMobile()) {
          closeDropdown();
          button.focus();
        }
      });

      tabBtn.addEventListener('keydown', (e) => {
        let targetIndex = i;
        
        if (isMobile()) {
          if (e.key === 'ArrowDown') {
            targetIndex = (i + 1) % tabButtons.length;
            e.preventDefault();
            tabButtons[targetIndex].focus();
          } else if (e.key === 'ArrowUp') {
            targetIndex = (i - 1 + tabButtons.length) % tabButtons.length;
            e.preventDefault();
            tabButtons[targetIndex].focus();
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            updateSelection(i);
            closeDropdown();
            button.focus();
          } else if (e.key === 'Tab') {
            closeDropdown();
            button.focus();
          }
        } else {
          if (e.key === 'ArrowRight') {
            targetIndex = (i + 1) % tabButtons.length;
            e.preventDefault();
            tabButtons[targetIndex].focus();
          } else if (e.key === 'ArrowLeft') {
            targetIndex = (i - 1 + tabButtons.length) % tabButtons.length;
            e.preventDefault();
            tabButtons[targetIndex].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            tabButtons[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            tabButtons[tabButtons.length - 1].focus();
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            updateSelection(i);
          }
        }
      });

      dropdown.addEventListener('keydown', (e) => {
        if (isMobile() && e.key === 'Escape') {
          closeDropdown();
          button.focus();
        }
      });
    });

    document.addEventListener('mousedown', (e) => {
      if (isMobile() && !dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (!prevButton.disabled) {
        scrollTabIntoView('prev');
      }
    });

    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (!nextButton.disabled) {
        scrollTabIntoView('next');
      }
    });

    closeDropdown();
    updateSelection(0, false);
    updateTabListMode();
    checkScrollbar();
    updateNavButtonState(0);

    window.addEventListener('resize', () => {
      updateTabListMode();
      checkScrollbar();
      
      const selectedIdx = tabButtons.findIndex(btn => btn.classList.contains('selected'));
      updateNavButtonState(selectedIdx >= 0 ? selectedIdx : 0);
    });
  });
});